import { trpc } from "@/app/router";
import { CreateDealModal } from "@/components/modals/deal/create-deal-modal";
import { ViewDealModal } from "@/components/modals/deal/view-deal-modal";
import { ProductEditModal } from "@/components/modals/product/product-edit-modal";
import { Pattern, match } from "ts-pattern";

import { useQueryClient } from "@tanstack/react-query";
import {
  Outlet,
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { useLocation } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { Suspense, useEffect, useMemo, useState } from "react";
import { Dialog, DialogContent } from "shadcn-ui";
import { z } from "zod";

// Initialize dayjs and TZ locale JP
dayjs.extend(utc);
dayjs.extend(timezone);

const searchSchema = z.object({
  dealId: z.string().optional(),
  type: z.enum(["edit", "view", "add"]).optional(),
  status: z
    .enum(["PENDING", "EXPIRED", "COMPLETED", "CANCELED", "RETURNED"])
    .default("PENDING")
    .catch("PENDING")
    .optional(),
  needRefresh: z.boolean().optional(),
});

export const Route = createFileRoute("/_app/inventory/deals/_modal")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
});

function RouteComponent() {
  const search = useSearch({
    from: "/_app/inventory/deals/_modal",
  });

  const navigate = useNavigate();
  const location = useLocation();

  const queryClient = useQueryClient();

  const isOpen = useMemo(
    () => !!search.type && !!search.dealId,
    [search],
  );

  const handleOnModalOpen = (v: boolean) => {
    if (!v) {
      navigate({
        to: location.pathname,
        search: {
          ...search,
          type: undefined,
          dealId: undefined,
        },
      });
    }
  };

  useEffect(() => {
    if (!isOpen && search.dealId && !search.type) {
      queryClient.removeQueries({
        queryKey: trpc.inventory.deal.getById.queryOptions({
          dealId: search.dealId,
        }).queryKey,
      });
      navigate({
        to: "/inventory/deals",
        search: {
          ...search,
          type: undefined,
          dealId: undefined,
        },
      });
    }

    // if (!isOpen && !search.type) {
    //   navigate({
    //     to: "/inventory/deals",
    //     search: {
    //       ...search,
    //       type: undefined,
    //       dealId: undefined,
    //     },
    //   });
    // }
  }, [search, isOpen, queryClient]);

  return (
    <div>
      <Outlet />
      {match([search.type, search.dealId])
        .with(["edit", Pattern.string], () => <ProductEditModal />)
        .with(["view", Pattern.string], () => <ViewDealModal />)
        .with(["add", Pattern.string], () => <CreateDealModal />)
        .otherwise(() => null)}
    </div>
  );
}
